import {
  Breadcrumb,
  Card,
  Divider,
  List,
  Space,
  Typography,
  notification,
} from "antd";
import { useLoaderData, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { firstOfCurrentMonth } from "~/utils";
import { breadcrumbHomeItem, breadcrumbItem } from "~/components";
import { HelpPageLoaderType } from "./loaders";
import MAIL_ICON from "~/images/mail-icon.png";
import PHONE_ICON from "~/images/phone-call-icon.png";
import { validVariables } from "~/utils/messageVariables";
import { useEffect } from "react";

// TODO Translate

const HelpPage = () => {
  const loaderData = useLoaderData() as HelpPageLoaderType;
  const { t } = useTranslation();

  const variableExamples = [
    "Deborah",
    "Holmes",
    firstOfCurrentMonth(),
    // TODO: there should be a way to get manager's name
    loaderData.userName,
  ];

  // For links to anchors, from https://stackoverflow.com/a/61311926
  // TODO: Ideally this would be in App.tsx, but that would require
  // fundamental changes to how routes are being provided.
  const { pathname, hash, key } = useLocation();
  useEffect(() => {
    // if not a hash link, scroll to top
    if (hash === "") {
      window.scrollTo(0, 0);
    } else {
      // else scroll to id
      setTimeout(() => {
        const id = hash.replace("#", "");
        const element = document.getElementById(id);
        element?.scrollIntoView();
      }, 0);
    }
  }, [pathname, hash, key]); // do this on route change

  return (
    <>
      <Breadcrumb
        separator=">"
        items={[breadcrumbHomeItem, breadcrumbItem(t("Help"))]}
      />

      <Space size="large" style={{ marginTop: "2rem" }}>
        <Card
          hoverable
          style={{ width: 300 }}
          bodyStyle={{
            justifyContent: "center",
            display: "grid",
          }}
        >
          <img
            src={PHONE_ICON}
            style={{
              width: 200,
              height: 200,
              marginBottom: "1rem",
              marginRight: "auto",
              marginLeft: "auto",
            }}
            alt=""
          />
          <Typography.Paragraph
            style={{ display: "grid", justifyContent: "center" }}
          >
            {t("Phone_help_card")}
          </Typography.Paragraph>

          <Typography.Text
            copyable
            onCopy={(text) =>
              notification.success({
                message: t("copied_to_clipboard") + " " + text,
              })
            }
            style={{ marginRight: "auto", marginLeft: "auto" }}
          >
            xxx-xxx-xxxx
          </Typography.Text>
        </Card>

        <Card
          hoverable
          style={{ width: 300 }}
          bodyStyle={{
            justifyContent: "center",
            display: "grid",
          }}
        >
          <img
            src={MAIL_ICON}
            style={{
              width: 200,
              height: 200,
              marginBottom: "1rem",
              marginRight: "auto",
              marginLeft: "auto",
            }}
          />
          <Typography.Paragraph
            style={{ display: "grid", justifyContent: "center" }}
          >
            {t("Eamil_help_card")}
          </Typography.Paragraph>

          <Typography.Text
            copyable
            onCopy={(text) =>
              notification.success({
                message: t("copied_to_clipboard") + " " + text,
              })
            }
            style={{ marginRight: "auto", marginLeft: "auto" }}
          >
            example@remod.com
          </Typography.Text>
        </Card>
      </Space>
      <Divider />
      {/* TODO: Translate */}
      <Typography.Title level={1} id="generalHelp">
        General Help
      </Typography.Title>
      <Typography.Title level={2} id="variables">
        Variables
      </Typography.Title>
      <Typography.Text>
        When creating a message to send to tenants, the message can be
        personalized by using variables. Variables are denoted by using square
        brackets with the name of the variable inside. Below is a list of
        variables you can use.
      </Typography.Text>
      <List>
        {validVariables.map((variable, index) => {
          return (
            <List.Item>
              <List.Item.Meta
                title={<span className="verbatim">[{variable.name}]</span>}
                description={`${variable.description} For example: ${variableExamples[index]}`}
              />
            </List.Item>
          );
        })}
      </List>
    </>
  );
};

export default HelpPage;
